import { FlexColumn, FlexRow } from "Components/Flex";
import { ConcertData } from "hooks/useUpcomingConcerts";
import { Button } from "melodies-source/Button";
import { Body1 } from "melodies-source/Text";
import { ConcertCard } from "./ConcertCard";
import { BuilderEventData } from "./hooks/useSetLiveBuilderEvents";
import { useRef } from "react";

interface DeleteConcertProps {
  concert: ConcertData;
  event?: BuilderEventData;
  loading?: boolean;
  onCancel?: () => void;
  onSubmit?: () => void;
}

export const DeleteConcert = ({
  concert,
  event,
  loading,
  onCancel,
  onSubmit,
}: DeleteConcertProps) => {
  const concertCopy = useRef(concert).current;

  return (
    <FlexColumn gap="20px">
      <Body1>Are you sure you want to delete this show?</Body1>
      <ConcertCard concert={concertCopy} event={event} />
      <FlexRow gap="20px" xEnd>
        <Button variant="tertiary" onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={onSubmit} loading={loading || !concert}>
          Delete
        </Button>
      </FlexRow>
    </FlexColumn>
  );
};
